import { Checkout } from "./Checkout";
import { Confirmation } from "./Confirmation";
import { CoverImageRaw } from "./CoverImageRaw";
import { Offer } from "./Offer";

export const CoverImage = Object.assign(CoverImageRaw, {
  Offer,
  Checkout,
  Confirmation,
});
